import { priceTooltipToggleTpl } from '../priceToggle/priceToggleTpl';

export const basketTpl = datas => {
  const hasFirstCottage = typeof datas.cottagesSelected[0] !== 'undefined' && datas.cottagesSelected[0].isFilled;
  const hasSecondCottage = typeof datas.cottagesSelected[1] !== 'undefined' && datas.cottagesSelected[1].isFilled;
  const cottageFirstClass = hasFirstCottage ? 'basket-cottageSelected' : 'basket-cottageToSelect';
  const cottageSecondClass = hasSecondCottage ? 'basket-cottageSelected' : 'basket-cottageToSelect';
  const isNL = GLOBAL_SCRIPTS.MARKET_CODE.toLowerCase() === 'nl';
  const isFR = GLOBAL_SCRIPTS.MARKET_CODE.toLowerCase() === 'fr';

  // days label
  const dayBeginNumber = new Date(datas.dateStart).getDay(),
    dayBeginWordingCode = 'day_' + dayBeginNumber,
    dayBegin = GLOBAL_SCRIPTS.WORDING_DAYS[dayBeginWordingCode].slice(0,3) + '.';

  const dayEndNumber = new Date(datas.dateEnd).getDay(),
    dayEndWordingCode = 'day_' + dayEndNumber,
    dayEnd = GLOBAL_SCRIPTS.WORDING_DAYS[dayEndWordingCode].slice(0,3) + '.';

  // Price cottage
  const datasPriceFirstCottage = {
    isFilled: true,
    price: datas.cottagesSelected[0].discountPrice !== 0 ? parseInt(datas.cottagesSelected[0].pricePromo) : parseInt(datas.cottagesSelected[0][isNL ? 'originalPrice' : 'originalPriceRawBeforeTax']),
    promo: datas.cottagesSelected[0].discountPrice !== 0 ? parseInt(datas.cottagesSelected[0].originalPrice) : 0,
    discountPrice: datas.cottagesSelected[0].discountPrice !== 0 ? datas.cottagesSelected[0].discountPrice : 0,
    photoDomainUrl: datas.cottagesSelected[0].photoDomainUrl
  };

  const priceFirstCottage = `
    <div class="accCart-priceContainer">
      ${datasPriceFirstCottage.promo ? GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? '<del>' + datasPriceFirstCottage.promo + '<span class="currency">' + datas.symbol + '</span></del>' : '<del><span class="currency before">' + datas.symbol + '</span>' + datasPriceFirstCottage.promo + '</del>' : ''}
      <div class="accCart-price">
        ${GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? datasPriceFirstCottage.price + '<span class="currency">' + datas.symbol + '</span>' : '<span class="currency before">' + datas.symbol + '</span>' + datasPriceFirstCottage.price}
      </div>
    </div>`;

  // Price second cottage
  let datasPriceSecondCottage = {};
  if (hasSecondCottage) {
    datasPriceSecondCottage = {
      isFilled: true,
      price: datas.cottagesSelected[1].discountPrice !== 0 ? parseInt(datas.cottagesSelected[1].pricePromo) : parseInt(datas.cottagesSelected[1][isNL ? 'originalPrice' : 'originalPriceRawBeforeTax']),
      promo: datas.cottagesSelected[1].discountPrice !== 0 ? parseInt(datas.cottagesSelected[1].originalPrice) : 0,
      discountPrice: datas.cottagesSelected[1].discountPrice !== 0 ? datas.cottagesSelected[1].discountPrice : 0,
      photoDomainUrl: datas.cottagesSelected[1].photoDomainUrl
    };
  }


  const priceSecondCottage = `
    <div class="accCart-priceContainer">
      ${datasPriceSecondCottage.promo ? GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? '<del>' + datasPriceSecondCottage.promo + '<span class="currency">' + datas.symbol + '</span></del>' : '<del><span class="currency before">' + datas.symbol + '</span>' + datasPriceSecondCottage.promo + '</del>' : ''}
      <div class="accCart-price">
        ${GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? datasPriceSecondCottage.price  + '<span class="currency">' + datas.symbol + '</span>' : '<span class="currency before">' + datas.symbol + '</span>' + datasPriceSecondCottage.price}
      </div>
    </div>`;

  const pricePromoTotal = ((parseInt(datasPriceFirstCottage.promo) || 0) + (parseInt(datasPriceSecondCottage.promo) || 0));
  const promoPriceDisplay = pricePromoTotal > 0 ? (GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? `<del>${pricePromoTotal}<span class="currency">${datas.symbol}</span></del>` : `<del><span class="currency">${datas.symbol}</span>${pricePromoTotal}</del>`) : '';

  const priceTotalCottages = `
    <div class="accCart-priceContainer">
      ${promoPriceDisplay}
      <div class="accCart-price">
        ${!GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? `<span class="currency before">${datas.symbol}</span>` : ''}
        ${parseInt(isNaN(datasPriceFirstCottage.price) ? 0 : datasPriceFirstCottage.price) + parseInt(isNaN(datasPriceSecondCottage.price) ? 0 : datasPriceSecondCottage.price)}
        ${GLOBAL_SCRIPTS.CURRENCY_IS_AFTER ? `<span class="currency">${datas.symbol}</span>` : ''}
      </div>
    </div>`;

  let dataTooltipOption = {
    tooltipOptions: {
      isLikeFancy: true,
      totalParticipants: datas.nbParticipants,
      productCode: datas.productCode
    },
    isLikeFancy: true,
    originalPriceRawBeforeTax: hasFirstCottage ? datas.cottagesSelected[0].price.originalPriceRawBeforeTax : datas.cottagesSelected[1].price.originalPriceRawBeforeTax,
    petsPrice: hasFirstCottage ? datas.cottagesSelected[0].price.pricePetsRawBeforeTax : datas.cottagesSelected[1].price.pricePetsRawBeforeTax,
    taxTotal: hasFirstCottage ? datas.cottagesSelected[0].price.taxTotal : datas.cottagesSelected[1].price.taxTotal,
    differencePriceRaw: hasFirstCottage ? datas.cottagesSelected[0].price.rawDifference : datas.cottagesSelected[1].price.rawDifference,
    discountLabel: hasFirstCottage ? datas.cottagesSelected[0].discountLabel : datas.cottagesSelected[1].discountLabel,
    maxPersons: hasFirstCottage ? datas.cottagesSelected[0].maxPersons : datas.cottagesSelected[1].maxPersons,
    housingLabel: hasFirstCottage ? datas.cottagesSelected[0].cottageLabel : datas.cottagesSelected[1].cottageLabel,
    includedServices: hasFirstCottage ? datas.cottagesSelected[0].includedServices.split(',') : datas.cottagesSelected[1].includedServices.split(','),
    participants: hasFirstCottage ? datas.multiParticipants[0] : datas.multiParticipants[1]
  };

  if (hasFirstCottage && hasSecondCottage) {
    dataTooltipOption.dataMulticottage = [];
    for (let i = 0; i < 2; ++i) {
      dataTooltipOption.dataMulticottage[i] = {
        participants: {
          senior: datas.multiParticipants[i].senior,
          adult: datas.multiParticipants[i].adult,
          ages: datas.multiParticipants[i].ages,
          pet: datas.multiParticipants[i].pet
        },
        cache: {
          maxPersons: datas.cottagesSelected[i].maxPersons
        },
        housing: {
          servicesIncludedV2: datas.cottagesSelected[i].includedServices.split(',')
        },
        housingLabel: datas.cottagesSelected[i].cottageLabel,
        price: {
          taxTotal: datas.cottagesSelected[i].price.taxTotal,
          rawDifference: datas.cottagesSelected[i].price.rawDifference,
          original: {
            rawBeforeTax: datas.cottagesSelected[i].price.originalPriceRawBeforeTax
          },
          pets: {
            valueBeforeTax: datas.cottagesSelected[i].price.pricePetsValueBeforeTax,
            rawBeforeTax: datas.cottagesSelected[i].price.pricePetsRawBeforeTax
          },
          promo: {
            rawBeforeTax: datas.cottagesSelected[i].price.pricePromo
          }
        }
      };
    }
  }

  const htmlPriceTooltipToggle = priceTooltipToggleTpl({
    pageTemplate: GLOBAL_SCRIPTS.CONTROLLER,
    blockClass: 'basket-tooltip',
    trackingPriceTooltipGaAction: 'basket tooltip',
    tooltipOptions: dataTooltipOption
  });

  let htmlBasket = '';

  const participantFirst = datas.multiParticipants[0];
  const participantSecond = datas.multiParticipants[1];

  if (hasFirstCottage || hasSecondCottage) {
    htmlBasket += `
    <div class="basket-container${!DEVICE.isBigDesktop ? ' closed' : !datas.openBasket ? '' : ' minimized'}${datas.translateOpening || (hasFirstCottage && hasSecondCottage) ? ' translateOpening' : ''}">
      <div class="c_loader">
        <div class="c_loader-bounce1"></div>
        <div class="c_loader-bounce2"></div>
        <div class="c_loader-bounce3"></div>
      </div>
      <div class="basket-header js-toggleBasket">
        <div class="toggleBasket">
          <i class="icon icon-arrow-left"></i>${GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.yourTrip}
        </div>
        <div class="basket-domainName">${datas.siteName}</div>
      </div>
      <div class="basket-line">
        <div class="basket-column basket-image">
          <img src="${typeof datas.cottagesSelected[0].photoDomainUrl !== 'undefined' ? datas.cottagesSelected[0].photoDomainUrl : typeof datas.cottagesSelected[1].photoDomainUrl !== 'undefined' ? datas.cottagesSelected[1].photoDomainUrl : ''}" />
        </div>
        <div class="basket-column">
          <div class="basket-line">
            <i class="icon icon-calendar"></i>
            <span class="basket-lineDateLabel"><span class="basket-lineDateLabelDay">${dayBegin}</span>${genericDate.toDisplay(new Date(datas.dateStart))}</span><span class="basket-lineDateLabelSeparator"> - </span><span class="basket-lineDateLabel"><span class="basket-lineDateLabelDay">${dayEnd}</span>${genericDate.toDisplay(new Date(datas.dateEnd))}</span>
          </div>
          <div class="basket-line">
            <i class="icon icon-couple"></i>
            <div class="nbParticipantsBasketBlock">
              <span class="nbParticipantsBasket">${datas.nbParticipants}</span>
              <span class="nbParticipantsLabel"> ${GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participantsLabel}</span>
            </div>
          </div>
          <div class="basket-line basket-lineLabel">
            <i class="icon icon-multiCottage"></i>
            <span class="nbCottage">2 ${GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.hebergementsLabel}</span>
          </div>
          <div class="basket-line basket-cottageLink">
            <span class="mainLink js-modify">${GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.modify}</span>
          </div>
        </div>
      </div>

      <div class="basket-lineCottage">
        <div class="${cottageFirstClass} first${!hasFirstCottage ? ' js-toggleBasket' : ''}${hasFirstCottage && hasSecondCottage ? ' hiddenOnMimimized' : ''}">
        ${hasFirstCottage ? '<i class="icon icon-check"></i>' : '<div class="basket-cottageToSelectIcon"><i class="icon icon-arrow-top"></i><span>1</span></div>'}
          <div class="${cottageFirstClass}Infos${hasFirstCottage ? ' js-openDetails' : ' js-goToCottage'}" ${hasFirstCottage ? 'data-housingcode="' + datas.cottagesSelected[0].housingCode + '"' : ''}">
            <span class="${cottageFirstClass}Label">${hasFirstCottage ? datas.cottagesSelected[0].cottageLabel : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.addCottageTitle + ' 1'}</span>
            <span class="${cottageFirstClass}Label--minimized">${hasFirstCottage ? datas.cottagesSelected[0].cottageLabel : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.first_housing}</span>
            <div class="${cottageFirstClass}Participants">
              <i class="icon icon-couple"></i>
              ${participantFirst.senior > 0 ? participantFirst.senior + '&nbsp;' + (participantFirst.senior === 1 ? GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelSenior : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelSeniors).toLowerCase() : ''}${participantFirst.adult > 0 ? (participantFirst.senior > 0 ? ', ' : '') + participantFirst.adult + '&nbsp;' + (participantFirst.adults === 1 ? GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labeladult : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelAdults).toLowerCase() : ''}${participantFirst.children > 0 ? ', ' + participantFirst.children + '&nbsp;' + (participantFirst.children === 1 ? GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelchild : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelChildren).toLowerCase() : ''}${participantFirst.pet > 0 ? ', ' + participantFirst.pet + '&nbsp;' + (participantFirst.pet === 1 ? GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelpet : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelPets).toLowerCase() : ''}
            </div>
          </div>
          ${hasFirstCottage ? '<div class="basket-cottageSelectedPrice">' + priceFirstCottage + '</div>' : ''}
        </div>
        ${hasFirstCottage ? '<div class="basket-cottageSelectedDelete js-deleteBasket" data-index="1"><i class="icon icon-close"></i></div>' : ''}
      </div>
      <div class="basket-lineCottage">
        <div class="${cottageSecondClass} second${!hasSecondCottage ? ' js-toggleBasket' : ''}${hasFirstCottage && hasSecondCottage ? ' hiddenOnMimimized' : ''}">
          ${hasSecondCottage ? '<i class="icon icon-check"></i>' : '<div class="basket-cottageToSelectIcon"><i class="icon icon-arrow-top"></i><span>2</span></div>'}
          <div class="${cottageSecondClass}Infos${hasSecondCottage ? ' js-openDetails' : ' js-goToCottage'}" ${hasSecondCottage ? 'data-housingcode="' + datas.cottagesSelected[1].housingCode + '"' : ''}>
            <span class="${cottageSecondClass}Label">${hasSecondCottage ? datas.cottagesSelected[1].cottageLabel : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.addCottageTitle + ' 2'}</span>
            <span class="${cottageSecondClass}Label--minimized">${hasSecondCottage ? datas.cottagesSelected[1].cottageLabel : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.second_housing}</span>
            <div class="${cottageSecondClass}Participants">
              <i class="icon icon-couple"></i>
              ${participantSecond.senior > 0 ? participantSecond.senior + '&nbsp;' + (participantSecond.senior === 1 ? GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelSenior : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelSeniors).toLowerCase() : ''}${participantSecond.adult > 0 ? (participantSecond.senior > 0 ? ', ' : '') + participantSecond.adult + '&nbsp;' + (participantSecond.adult === 1 ? GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labeladult : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelAdults).toLowerCase() : ''}${participantSecond.children > 0 ? ', ' + participantSecond.children + '&nbsp;' + (participantSecond.children === 1 ? GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelchild : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelChildren).toLowerCase() : ''}${participantSecond.pet > 0 ? ', ' + participantSecond.pet + '&nbsp;' + (participantSecond.pet === 1 ? GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelpet : GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.participants_labelPets).toLowerCase() : ''}
            </div>
          </div>
          ${hasSecondCottage ? '<div class="basket-cottageSelectedPrice">' + priceSecondCottage + '</div>' : ''}
        </div>
        ${hasSecondCottage ? '<div class="basket-cottageSelectedDelete js-deleteBasket" data-index="2"><i class="icon icon-close"></i></div>' : ''}
      </div>
    ${hasFirstCottage && hasSecondCottage ? '<div class="basket-cottageToSelect third"><i class="icon icon-check"></i><div class="basket-cottageSelectedInfos"><span class="basket-cottageSelectedLabel">' + GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.basket_choiceDone + '</span></div></div>' : ''}`;

    const wordingMentions = typeof GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.basket_mentions !== 'undefined' ? GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.basket_mentions : '';

    let dataSetBooking = '';

    if (hasFirstCottage && hasSecondCottage) {
      const bookingDatas = {
        adultsnb: participantFirst.adult,
        seniorsnb: participantFirst.senior,
        childrennb: participantFirst.children,
        ages: JSON.stringify(participantFirst.ages),
        petsnb: participantFirst.pet,
        adultsnb2: participantSecond.adult,
        seniorsnb2: participantSecond.senior,
        childrennb2: participantSecond.children,
        ages2: JSON.stringify(participantSecond.ages),
        petsnb2: participantSecond.pet,
        code: datas.productCode,
        start: datas.dateStart,
        housingcode: datas.cottagesSelected[0].housingCode,
        housingcode2: datas.cottagesSelected[1].housingCode,
        duration: datas.duration,
        actioncodecode: datas.cottagesSelected[0].actionCode,
        actioncodecode2: datas.cottagesSelected[1].actionCode
      };
      for (let key in bookingDatas) {
        dataSetBooking += ` data-${key}="${bookingDatas[key]}"`;
      }
    }

    const floaCondition = typeof GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.basket_floa_condition !== 'undefined' ? GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.basket_floa_condition.replace(/[\u00A0-\u9999<>&]/g, function(i) {
      return '&#'+i.charCodeAt(0)+';';}) : '';
    const floaContent = isFR ? `
      <div class="basket-footer__floa">
        <span class="basket-footer__floa-text">
          ${GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.basket_floa_notice}
        </span>
        <img class="basket-footer__floa-image" src="${GLOBAL_SCRIPTS.STATIC_VERSION}/assets/images/basket/4xfloa.svg" />
        <span class="priceTooltip-toggle js-priceTooltip-toggle icon icon-information click_event--init" data-pricetooltip="{&quot;simpleText&quot;:&quot;${floaCondition}&quot;}">
        </span>
      </div>
      ` : '';

    htmlBasket += `
      <ul class="basket-mentions">
        ${datas.sideBySide ? `
        ${'<li>' + GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.basket_mentions_sidebyside + '</li>'}` : ''}
        ${'<li>' + wordingMentions.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '</li>\n<li>' + '$2') + '</li>'}
      </ul>
      <div class="basket-footer">
        <div class="basket-footer__actions">
          <div class="basket-footer__actions-price${hasFirstCottage && hasSecondCottage ? ' fullHeight' : ' hiddenOnMimimized'}">${hasFirstCottage || hasSecondCottage ? priceTotalCottages : hasFirstCottage ? priceFirstCottage : priceSecondCottage}${htmlPriceTooltipToggle}</div>
          <span class="button button--pinkWhite${hasFirstCottage && hasSecondCottage ? ' js-booking js-buttonLoader' : ' disabled'}"${dataSetBooking}>
            <i class="icon icon-shopcart"></i>${GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.basket_nextStep_button}
          </span>
        </div>
        ${floaContent}
      </div>
      </div>
    </div>
    <div class="basket-openerMobile">
      <i class="icon icon-shopcart"></i>
      ${GLOBAL_SCRIPTS.WORDINGS_MULTICOTTAGE.basket_votre_sejour}
      <i class="icon icon-arrow"></i>
    </div>`;
  }

  return htmlBasket;
};